import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import { HpRespModuleContainer } from '../HpRespModuleContainer/HpRespModuleContainer';
import HpRespLocationsModuleItem from './HpRespLocationsModuleItem';
import HpRespLocationsModuleItemList from './HpRespLocationsModuleItemList';
import {
    trackShopByLocationsImpressions,
    trackShopByLocationClick,
} from '../helpers/shopByTracking';
import { trackModuleLocation } from '../helpers/moduleLocationTracking';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';
import { HpRespLocationItems } from './HpRespLocationItems';
import { LOCATION_ITEM_PAGE_COUNT } from '../constants';

import styles from './HpRespLocationsModule.scss';

export const handleInitialDisplay = ({ inViewport, locations }) => {
    if (locations && inViewport) {
        locations.map((location, index) => {
            const { linkData } = location;
            trackShopByLocationsImpressions(index, linkData?.path, false);
        });
    }
};

export const HpRespLocationsModuleComponent = ({
    componentModule,
    isMobile,
    itemsPerPage,
    viewer,
    useLazyLoadImages,
    moduleIndex,
    totalModules,
}) => {
    const { items, title, subtitle } = componentModule;
    const locations = items || [];

    if (!locations.length) {
        return null;
    }

    return (
        <HpRespModuleContainer addTopGap={!title}>
            <PageLayout setOffset={!isMobile} setViewportBackground={'sassyColorWhite'}>
                <div className={styles.content}>
                    <HpRespModuleContainer.Header title={title} subtitle={subtitle} />
                    <SharedInViewport
                        stopWhenInViewport
                        onInViewportChange={({ inViewport }) =>
                            handleInitialDisplay({
                                locations,
                                inViewport,
                            })
                        }
                    >
                        <div className={styles.locations}>
                            {locations.map((item, index) => {
                                return (
                                    <HpRespLocationsModuleItem
                                        key={item?.cmsId || index}
                                        item={item}
                                        onClick={() => {
                                            trackShopByLocationClick(item, index);
                                            trackModuleLocation({
                                                label: 'four block module',
                                                moduleIndex,
                                                totalModules,
                                            });
                                        }}
                                    />
                                );
                            })}
                            <HpRespLocationsModuleItemList
                                componentModule={componentModule}
                                onListItemClick={() =>
                                    trackModuleLocation({
                                        label: 'four block module',
                                        moduleIndex,
                                        totalModules,
                                    })
                                }
                            />
                        </div>
                        <HpRespLocationItems
                            viewer={viewer}
                            itemCount={itemsPerPage * LOCATION_ITEM_PAGE_COUNT}
                            useLazyLoadImages={useLazyLoadImages}
                            moduleIndex={moduleIndex}
                            totalModules={totalModules}
                        />
                    </SharedInViewport>
                </div>
            </PageLayout>
        </HpRespModuleContainer>
    );
};

HpRespLocationsModuleComponent.propTypes = {
    componentModule: PropTypes.object,
    viewer: PropTypes.object,
    itemsPerPage: PropTypes.number,
    isMobile: PropTypes.bool,
    useLazyLoadImages: PropTypes.bool,
    moduleIndex: PropTypes.number,
    totalModules: PropTypes.number,
};

export const HpRespLocationsModule = createFragmentContainer(HpRespLocationsModuleComponent, {
    viewer: graphql`
        fragment HpRespLocationsModule_viewer on Viewer {
            ...HpRespLocationItems_viewer
        }
    `,
    componentModule: graphql`
        fragment HpRespLocationsModule_componentModule on LocationsModule {
            title
            subtitle
            items {
                cmsId
                linkData {
                    # Used by HpRespLocationsModuleItem
                    path
                }
                ...HpRespLocationsModuleItem_item
            }
            ...HpRespLocationsModuleItemList_componentModule
        }
    `,
});
